__turbopack_context__.v({
  "aiActions": "RichAIField-module__40ix3q__aiActions",
  "container": "RichAIField-module__40ix3q__container",
  "divider": "RichAIField-module__40ix3q__divider",
  "error": "RichAIField-module__40ix3q__error",
  "errorBannerWrapper": "RichAIField-module__40ix3q__errorBannerWrapper",
  "errorIcon": "RichAIField-module__40ix3q__errorIcon",
  "errorText": "RichAIField-module__40ix3q__errorText",
  "fieldWrapper": "RichAIField-module__40ix3q__fieldWrapper",
  "focused": "RichAIField-module__40ix3q__focused",
  "formatButton": "RichAIField-module__40ix3q__formatButton",
  "formatButtonActive": "RichAIField-module__40ix3q__formatButtonActive",
  "inlinePlaceholderMenu": "RichAIField-module__40ix3q__inlinePlaceholderMenu",
  "interactive": "RichAIField-module__40ix3q__interactive",
  "placeholderMenu": "RichAIField-module__40ix3q__placeholderMenu",
  "placeholderMenuItem": "RichAIField-module__40ix3q__placeholderMenuItem",
  "placeholderMenuItemActive": "RichAIField-module__40ix3q__placeholderMenuItemActive",
  "placeholderMenuToken": "RichAIField-module__40ix3q__placeholderMenuToken",
  "placeholderMenuWrapper": "RichAIField-module__40ix3q__placeholderMenuWrapper",
  "placeholderToken": "RichAIField-module__40ix3q__placeholderToken",
  "skeletonLine": "RichAIField-module__40ix3q__skeletonLine",
  "skeletonOverlay": "RichAIField-module__40ix3q__skeletonOverlay",
  "skeletonShimmer": "RichAIField-module__40ix3q__skeletonShimmer",
  "toolbar": "RichAIField-module__40ix3q__toolbar",
});
